<script lang="ts">
  import { LatLng, LatLngBounds, Map, Point, TileLayer } from "leaflet";
  import { onDestroy, onMount, setContext } from "svelte";
  import Marker from "./Marker.svelte";
  import { hover, identifier, positions } from "./stores";
  import type { Position } from "./types";
  import Zoom from "./Zoom.svelte";

  setContext("map", {
    getMap: () => map,
  });

  const topLeft: Point = new Point(320, 80);

  const updateBounds = (positions: Position[], identifier: string): LatLngBounds => {
    const coordinates: LatLng[] = positions
      .filter((pos) => identifier === pos.identifier || identifier === "")
      .map((pos) => {
        return new LatLng(pos.referenceCoordinates.y.decimalValue, pos.referenceCoordinates.x.decimalValue);
      });
    const count = coordinates.length;
    if (coordinates.length === 0) {
      return null;
    }
    if (coordinates.length === 1) {
      const [coordinate] = coordinates;
      return new LatLngBounds(coordinate, coordinate);
    }
    if (coordinates.length > 1) {
      const bounds: LatLngBounds = new LatLngBounds(null);
      coordinates.forEach((coord) => bounds.extend(coord));
      return bounds;
    }
    return null;
  };

  let bounds: LatLngBounds;
  let container: HTMLDivElement;
  let layer: TileLayer;
  let map: Map;

  $: bounds = updateBounds($positions, $identifier);
  $: map && bounds
    ? map.fitBounds(bounds, {
        duration: 0.75,
        paddingTopLeft: topLeft,
        maxZoom: 17,
      })
    : null;

  onMount(() => {
    map = new Map(container, {
      center: [64.5, 10.0],
      minZoom: 5,
      zoom: 5,
      zoomControl: false,
    });

    layer = new TileLayer("https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png", {
      attribution: "&copy; Kartverket",
    });
    map.addLayer(layer);
  });
  onDestroy(() => {
    if (map) {
      map.remove();
    }
  });
</script>

<div class="map-container" bind:this={container}>
  {#if map}
    {#each $positions as pos}
      <Marker
        active={pos.identifier === $identifier}
        hover={pos.identifier === $hover}
        lat={pos.referenceCoordinates.y.decimalValue}
        lng={pos.referenceCoordinates.x.decimalValue}
        on:click={() => identifier.set(pos.identifier)}
        on:mouseout={() => hover.set("")}
        on:mouseover={() => hover.set(pos.identifier)}
      />
    {/each}
  {/if}
</div>
{#if map}
  <Zoom />
{/if}

<style>
  .map-container {
    height: 100%;
    width: 100%;
    z-index: 0;
  }
</style>
